import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Clock } from 'lucide-react';
import api from '../../lib/api';
import { useAuth } from '../../hooks/useAuth';

const TrialBanner: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);
  const [trialEndsAt, setTrialEndsAt] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !user.orgId) {
      setLoading(false);
      return;
    }

    api.get('/organizations/me')
      .then((res) => {
        const org = res.data;
        if (org.status === 'trial' && org.trialEndsAt) {
          setTrialEndsAt(org.trialEndsAt);
        }
      })
      .catch(() => {
        // fail silently
      })
      .finally(() => setLoading(false));
  }, [user]);

  if (loading || dismissed || !trialEndsAt) return null;

  const now = new Date();
  const end = new Date(trialEndsAt);
  const diffMs = end.getTime() - now.getTime();

  // אם פג התוקף — לא מציגים
  if (diffMs <= 0) return null;

  const daysLeft = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  // צבעים לפי כמות ימים
  let bannerClass = '';
  if (daysLeft <= 1) {
    bannerClass = 'bg-red-600 text-white';
  } else if (daysLeft <= 2) {
    bannerClass = 'bg-orange-500 text-white';
  } else {
    bannerClass = 'bg-blue-600 text-white';
  }

  return (
    <div
      dir="rtl"
      className={`w-full flex items-center justify-between px-4 py-2 text-sm font-medium flex-shrink-0 ${bannerClass}`}
      style={{ zIndex: 9999 }}
    >
      {/* אייקון + טקסט */}
      <div className="flex items-center gap-2">
        <Clock size={15} className="flex-shrink-0" />
        <span>
          🕐 ניסיון חינם |{' '}
          <strong>
            {daysLeft === 1 ? 'יום אחד נותר' : `${daysLeft} ימים נותרו`}
          </strong>
        </span>
      </div>

      {/* כפתורים */}
      <div className="flex items-center gap-3 mr-4">
        <button
          onClick={() => navigate('/billing')}
          className="bg-white text-blue-700 hover:bg-gray-100 font-bold rounded-lg px-3 py-1 text-xs transition-colors duration-150"
          style={daysLeft <= 1 ? { color: '#dc2626' } : daysLeft <= 2 ? { color: '#ea580c' } : {}}
        >
          שדרג עכשיו
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="opacity-80 hover:opacity-100 transition-opacity"
          aria-label="סגור"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default TrialBanner;
